import { Button, Dialog, DialogContent, DialogFooter, Icon, Image, Typography } from "@backpac/monica";
import type React from "react";
import { Temporal } from "temporal-polyfill";

import NewPayoutBannerImage from "~/assets/new-payout-banner.png";

const NEW_PAYMENT_BANNER_KEY = "backpac-new-payment-banner-shown";
const NOW = Temporal.Now.zonedDateTimeISO("America/Los_Angeles");

class NewPayoutBannerStatus {
  // valid until 2025-07-31
  public hasNewPayoutBanner = (() => {
    return NOW.month < 8;
  })();

  public get isShowPopup() {
    if (!this.hasNewPayoutBanner) return false;

    const storedDate = localStorage.getItem(NEW_PAYMENT_BANNER_KEY);
    if (!storedDate) return true;

    try {
      const lastShownDate = Temporal.PlainDate.from(storedDate);
      const currentDate = NOW.toPlainDate();
      const daysSinceLastShown = currentDate.since(lastShownDate).days;
      return this.hasNewPayoutBanner && daysSinceLastShown >= 7;
    } catch (e) {
      console.error(e);
      return true;
    }
  }

  public setPopupHidden() {
    localStorage.setItem(
      NEW_PAYMENT_BANNER_KEY,
      Temporal.Now.zonedDateTimeISO("America/Los_Angeles").toPlainDate().toString(),
    );
  }
}

export const newPayoutBannerStatus = new NewPayoutBannerStatus();

type NewPayoutBannerProps = {
  open: boolean;
  onClose: () => void;
};

interface NewPayoutBanner extends React.FC<NewPayoutBannerProps> {
  status: NewPayoutBannerStatus;
}

export const NewPayoutBanner: NewPayoutBanner = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent hideCloseButton className="max-w-[320px] p-0 gap-0 rounded-none sm:rounded-none border-none">
        <Image src={NewPayoutBannerImage} alt="Promotion Banner" width={320} height={380} />
        <DialogFooter className="flex h-48px mt-0 flex-row p-16px justify-between sm:justify-between">
          <Button
            variant="ghost"
            className="flex items-center gap-4px"
            onClick={() => {
              newPayoutBannerStatus.setPopupHidden();
              onClose();
            }}
            tabIndex={-1}
          >
            <Icon name="check" className="size-3" />
            <Typography size="xs" color="textPrimary">
              Don't show again for 7 days
            </Typography>
          </Button>
          <Button
            variant="ghost"
            className="flex items-center gap-4px focus-visible:outline-none focus-visible:ring-0"
            onClick={onClose}
          >
            <Typography size="xs" color="black">
              OK
            </Typography>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

NewPayoutBanner.status = new NewPayoutBannerStatus();
